import React from "react"
import Pie from "../../../generic-components/charts/pie/Pie"

const UserBehaviourPieChart = ({ pieData, id }) => {
  return (
    <Pie data={pieData} id={id} className="user-behaviour-chart__chart-container"/>
  )
}

export default UserBehaviourPieChart